
export default function FeaturesSection() {
  const features = [
    {
      icon: "fas fa-hand-holding-usd",
      title: "No Upfront Fees",
      description: "Pay only when we successfully settle your debt. No hidden costs or surprise charges."
    },
    {
      icon: "fas fa-chart-line",
      title: "Proven Track Record",
      description: "Over $500M in debt settled with a 16+ year history of helping clients achieve freedom."
    },
    {
      icon: "fas fa-user-tie",
      title: "Personalized Plans",
      description: "Custom debt settlement strategies tailored to your unique financial situation."
    },
    {
      icon: "fas fa-certificate",
      title: "Licensed Professionals",
      description: "Experienced, licensed debt settlement specialists with BBB accreditation."
    },
    {
      icon: "fas fa-clock",
      title: "Fast Results",
      description: "Most clients see significant debt reduction within 6-24 months of starting."
    },
    {
      icon: "fas fa-headset",
      title: "Ongoing Support",
      description: "Dedicated support team available throughout your entire debt settlement journey."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Businesses & Consumers <span className="text-orange-500">Trust</span> Brite Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We've been helping Americans reclaim their financial freedom since 2008 with proven strategies and personalized service.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
